import React from "react";
import { useNavigate } from "react-router-dom";
import { List, Rows } from "lucide-react";
import { useTranslation } from "react-i18next";

const CreateListOrSegment: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="create-list-segment-container">
      <button
        className="button button--primary list-segment-back-button"
        onClick={() => navigate("/account/engagement/audience")}
      >
        {t("audienceOverview.createListOrSegment.back")}
      </button>

      <h1 className="list-segment-page-title">
        {t("audienceOverview.createListOrSegment.title")}
      </h1>
      <p className="list-segment-page-subtitle">
        {t("audienceOverview.createListOrSegment.subtitle")}
      </p>

      <div className="selection-box">
        <div className="selection-options">
          <button
            type="button"
            className="selection-card list"
            onClick={() => navigate("/account/engagement/create-list")}
          >
            <div className="audience_icon">
              <List size={30} />
            </div>
            <h4 className="card-title">
              {t("audienceOverview.createListOrSegment.listTitle")}
            </h4>
            <p className="card-description">
              {t("audienceOverview.createListOrSegment.listDescription")}
            </p>
          </button>

          <button
            type="button"
            className="selection-card segment"
            onClick={() => navigate("/account/engagement/create-segment")}
          >
            <div className="audience_icon">
              <Rows size={30} />
            </div>
            <h4 className="card-title">
              {t("audienceOverview.createListOrSegment.segmentTitle")}
            </h4>
            <p className="card-description">
              {t("audienceOverview.createListOrSegment.segmentDescription")}
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateListOrSegment;
